import { Dispatch, SetStateAction, useState } from "react";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import {
  Modal,
  Button,
  MenuItem,
  Select,
} from "@mui/material";

interface ModalProps {
  open: boolean;
  onClose: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
}

export default function AddFeature({
  open,
  onClose,
  setOpen,
}: ModalProps) {

const [featureForm, setFeatureForm] = useState({
  featureName: "",
  description: "",
  module: "",
  scope: "Scope",
  guardrailLevel: "Guardrail",
  rollout: "",
});

const handleChange = (field: string, value: any) => {
  setFeatureForm((prev) => ({
    ...prev,
    [field]: value,
  }));
};

  return (
    <Modal
      className="modal rejectReason_modal"
      open={open}
      onClose={onClose}
    >
      <div className="modal-dialog take_action_modal">
        <div className="modal-body">

          {/* Header */}
          <div className="modal_title">
            <h2>Add Feature</h2>
            <button
              type="button"
              className="btn-close"
              onClick={() => setOpen(false)}
            >
              <CloseIcon />
            </button>
          </div>

          {/* Form */}
          <form className="form">
            <div className="gap_p">

              {/* Feature Name */}
              <div className="control_group w_50">
                <label htmlFor="feature-name">Feature Name</label>
                <TextField
                  placeholder="Enter feature name"
                  fullWidth
                  hiddenLabel
                  inputProps={{ id: "feature-name" }}
                />
              </div>

              {/* Module */}
              <div className="control_group w_50">
                <label htmlFor="feature-module">Module</label>
                <TextField
                  placeholder="e.g. Pricing Engine, Analytics"
                  fullWidth
                  hiddenLabel
                  inputProps={{ id: "feature-module" }}
                />
              </div>

              {/* Scope */}
              <div className="control_group w_50">
                <label htmlFor="feature-scope">Scope</label>
                <Select fullWidth displayEmpty value={featureForm.scope} onChange={(e) => handleChange("scope", e.target.value)} inputProps={{ id: "feature-scope" }}>
                  <MenuItem value="Scope">Select Scope</MenuItem>
                  <MenuItem value="Admin">Admin</MenuItem>
                  <MenuItem value="Vendor">Vendor</MenuItem>
                  <MenuItem value="Admin / Vendor">Admin / Vendor</MenuItem>
                  <MenuItem value="Marketing">Marketing</MenuItem>
                </Select>
              </div>

              {/* Guardrail Level */}
              <div className="control_group w_50">
                <label htmlFor="guardrail-level">Guardrail Level</label>
                <Select fullWidth displayEmpty value={featureForm.guardrailLevel} onChange={(e) => handleChange("guardrailLevel", e.target.value)} inputProps={{ id: "guardrail-level" }}>
                  <MenuItem value="Guardrail">Select Level</MenuItem>
                  <MenuItem value="Low">Low</MenuItem>
                  <MenuItem value="Medium">Medium</MenuItem>
                  <MenuItem value="High">High</MenuItem>
                </Select>
              </div>

              {/* Rollout */}
              <div className="control_group w_50">
                <label htmlFor="feature-rollout">Rollout (%)</label>
                <TextField
                  type="number"
                  placeholder="e.g. 25"
                  fullWidth
                  hiddenLabel
                  inputProps={{ id: "feature-rollout" }}
                />
              </div>

              {/* Description */}
              <div className="control_group ai_rec_btn">
                <label htmlFor="feature-description">Description</label>
                <TextField
                  placeholder="Brief description of the feature..."
                  fullWidth
                  multiline
                  rows={4}
                  hiddenLabel
                  inputProps={{ id: "feature-description" }}
                />
                <Button className="btn btn_primary sm">
                  <img src="/static/images/ai_icon.svg" alt="ai_icon"/>
                  Enhance with AI
                </Button>
              </div>

            </div>

            {/* Footer */}
            <div className="footer_btn_flex">
              <Button
                className="btn btn_grey"
                variant="outlined"
                onClick={() => setOpen(false)}
              >
                Cancel
              </Button>

              <Button
                className="btn btn_primary"
                onClick={() => setOpen(false)}
              >
                Add
              </Button>
            </div>
          </form>

        </div>
      </div>
    </Modal>
  );
}